<template>
    <component
        v-if="loggedUser"
        :is="isAdmin ? 'AdminDashboard' : 'UserDashboard'"
    />
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'home',

    components: {
        AdminDashboard: () => import('@/views/AdminDashboard'),
        UserDashboard: () => import('@/views/UserDashboard')
    },

    computed: {
        ...mapGetters({
            loggedUser: 'auth/getLoggedUser',
            isAdmin: 'auth/isAdmin'
        })
    }
};
</script>
